import { render, staticRenderFns } from "./AddInprogressShopsDialog.vue?vue&type=template&id=5cfa127a&scoped=true"
import script from "./AddInprogressShopsDialog.vue?vue&type=script&lang=ts"
export * from "./AddInprogressShopsDialog.vue?vue&type=script&lang=ts"
import style0 from "./AddInprogressShopsDialog.vue?vue&type=style&index=0&id=5cfa127a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfa127a",
  null
  
)

export default component.exports